
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium-tools",
      function () {
        return require("private-next-pages/premium-tools/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premium-tools"])
      });
    }
  